import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-search-company',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-company.component.html',
  styleUrls: ['./search-company.component.scss']
})
export class SearchCompanyComponent implements OnInit {
  @Output() simpleSearch = new EventEmitter<string>();

  allTime: string[] = [];
  last30: string[] = [];
  last7: string[] = [];


  constructor(private srchSvc: SearchService) { }

  async ngOnInit()  {

  }

  companySearch(term: string) {
    this.simpleSearch.emit(term);
  }
}
